<template>
  <div class="container">

    <heading-one class="-margin-md">ログイン方法のご選択</heading-one>

    <notice-box class="-success _mb-sm-40 _mb-md-20">
      <btngroup-single>
        <btn-main @click.prevent="doLogin" class="-main">
          au IDログイン
        </btn-main>
      </btngroup-single>
    </notice-box>

    <list-group class="-link _mb-sm-60 _mb-md-90">
      <list-item class="-link" href="https://qa.kddi-fs.com/faq/show/4325?back=front%2Fcategory%3Ashow&category_id=343&page=1&site_domain=loan&sort=sort_new&sort_order=desc" target="_blank">
        <heading-icon class="_mb-0">
          <p class="heading _mb-0 -textleft">パスワードをお忘れなど、ログインでお困りの方はこちら</p>
          <icon-box src="out" class="icon -xs _ml-sm-5 _ml-md-10"></icon-box>
        </heading-icon>
      </list-item>
    </list-group>

    <section>
      <card-groups class="_mb-30">
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.accordion0 class="-plus">
              <h3 class="heading">au IDを解約されたお客さま<br>au回線契約を家族間譲渡されたお客さま</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="accordion0" accordion="accordion" :visible="false">
            <card-body>
              <p>au IDを解約またはau回線契約を家族間譲渡されたお客さまは、au IDでのログインができません。ログインID（メールアドレス）でのログインに変更となります。</p>
              <p>
                <span class="-txtdanger">ログインIDを登録されたお客さまは、セブン銀行スマホATM等、一部サービスの利用に制限がございます。</span><br>
                詳しくは<a href="https://qa.kddi-fs.com/faq/show/10849?category_id=343&site_domain=loan" class="btn-text textlink" target="_blank">こちら</a>
              </p>

              <div class="notice-wrap">
                <notice-box class="-cancel _mb-sm-10 _mr-md-20">
                  <notice-header>
                    <h3 class="heading">ログインID（メールアドレス）をご登録済みのお客さま</h3>
                  </notice-header>
                  <notice-body>ログインID（メールアドレス）でログインしてください。</notice-body>
                  <btngroup-single>
                    <btn-main routerName="ce002" class="-normal">
                      ログインIDでログイン
                    </btn-main>
                  </btngroup-single>
                </notice-box>
                <notice-box class="-cancel _ml-md-20">
                  <notice-header>
                    <h3 class="heading">ログインID（メールアドレス）のご登録がお済みでないお客さま</h3>
                  </notice-header>
                  <notice-body>初回のログイン設定を行ってください。</notice-body>
                  <btngroup-single>
                    <btn-main routerName="ce003" class="-normal">
                      初回ログイン設定画面へ
                    </btn-main>
                  </btngroup-single>
                </notice-box>
              </div>
            </card-body>
          </collapse-item>
        </card-box>
      </card-groups>
    </section>

  </div><!-- container -->
</template>

<script>
import { initializCredentials } from '../utils/Auth'
import { checkMaintenance } from '../utils/MaintenanceHelper'
import HeadingOne from '../components/heading/HeadingOne'
import HeadingTwo from '../components/heading/HeadingTwo'
import NoticeBox from '../components/box/NoticeBox'
import NoticeBody from '../components/box/NoticeBody'
import NoticeHeader from '../components/box/NoticeHeader'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import IconBox from '../components/icons/icon-box'
import HeadingIcon from '../components/heading/HeadingIcon'
import CardGroups from '../components/card/CardGroups'
import CardBox from '../components/card/CardBox'
import CardHeader from '../components/card/CardHeader'
import CardBody from '../components/card/CardBody'
import BtnToggle from '../components/button/BtnToggle'
import CollapseItem from '../components/collapse/CollapseItem'

export default {
  name: 'Ce-001',
  metaInfo: {
    title: 'ログイン方法のご選択',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ローカルID,認証方法'}
    ]
  },
  components: {
    HeadingIcon,
    IconBox,
    ListItem,
    ListGroup,
    BtnMain,
    BtngroupSingle,
    NoticeHeader,
    NoticeBody,
    NoticeBox,
    HeadingTwo,
    HeadingOne,
    CardGroups,
    CardBox,
    CardHeader,
    CardBody,
    BtnToggle,
    CollapseItem
  },
  data () {
    return {
      isDisabled: false
    }
  },
  methods: {
    doLogin: function () {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        let redirectPageId = window.$cookies.get('redirect_page_id')
        initializCredentials('login', redirectPageId).then(res => {
          let redirectUrl = res.redirect_url
          window.location.href = redirectUrl
          window.$cookies.remove('redirect_page_id', '/')
        }).catch(error => {
          this.goToErrorPage(error)
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    }
  },
  mounted () {
    checkMaintenance('MB-001').then(res => {
      if (res.check_result === 'NG') {
        this.$router.push({name: 'er004'})
      }
    }).catch(error => {
      this.goToErrorPage(error)
    })
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";

  .heading-icon {
    justify-content: start !important;
    .heading {
      font-size: 16px !important;
      a {
        text-decoration: underline;
      }
    }
  }

  .heading-two {
    display: flex;
    flex-direction: column;
    h2 {
      text-align: center;
    }
  }

  .notice-wrap {
    @include mq-up(md) {
      display: flex;
      justify-content: space-between;
    }
    >.notice-box {
      text-align: left !important;
      @include mq-up(md) {
        display: flex;
        flex-direction: column;
        width: 50%;
      }
      >.notice-body {
        margin-bottom: 20px;
        @include mq-up(md) {
          margin-bottom: 30px;
        }
      }
      >.btngroup-single {
        margin-top: auto;
      }
    }
  }

  .-txtdanger {
    a {
      &:link,
      &:visited {
        color: $danger;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Ce001.vue